import { useNavigate, useSearchParams } from "react-router-dom";
import { Mountain, CheckCircle } from "lucide-react";
import { useSurveyForm } from "@/hooks/useSurveyForm";
import { AboutRiderSection, ProgrammeSection, BudgetSection, ContactSection } from "@/components/survey/SurveyFormSections";
import { getTranslations } from "@/components/survey/surveyTranslations";

export default function SurveyPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const lang = searchParams.get("lang") || "en";
  const t = getTranslations(lang);
  const { form, updateField, submitted, loading, submit } = useSurveyForm();

  if (submitted) {
    return (
      <div className="min-h-screen bg-[#0A0A0A] flex items-center justify-center px-6">
        <div className="text-center">
          <CheckCircle className="w-16 h-16 text-[#32D74B] mx-auto mb-6" />
          <h1 className="font-heading text-3xl text-white uppercase mb-4">{lang === "es" ? "GRACIAS" : "THANK YOU"}</h1>
          <p className="text-[#A3A3A3] font-body mb-8">{t.success}</p>
          <button onClick={() => navigate("/")} className="bg-[#FF3B30] text-white font-heading uppercase tracking-widest px-8 py-3 text-sm hover:bg-[#FF5C53] transition-all">
            {lang === "es" ? "Volver a LNMA" : "Back to LNMA"}
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#0A0A0A]" data-testid="survey-page">
      <div className="border-b border-[#262626] bg-black/60 backdrop-blur-xl">
        <div className="max-w-3xl mx-auto px-6 h-16 flex items-center gap-3">
          <Mountain className="w-6 h-6 text-[#FF3B30]" />
          <span className="font-heading text-lg tracking-[0.15em] text-white">LNMA</span>
        </div>
      </div>

      <div className="max-w-3xl mx-auto px-6 py-12">
        <div className="flex items-center gap-3 mb-4">
          <div className="w-8 h-[2px] bg-[#FF3B30]" />
          <span className="text-xs uppercase tracking-[0.3em] text-[#A3A3A3] font-body">{t.subtitle}</span>
        </div>
        <h1 className="font-heading text-4xl sm:text-5xl uppercase tracking-tight text-white mb-12">{t.title}</h1>

        <form onSubmit={submit} className="space-y-12">
          <AboutRiderSection t={t} form={form} u={updateField} />
          <ProgrammeSection t={t} form={form} u={updateField} />
          <BudgetSection t={t} form={form} u={updateField} />
          <ContactSection t={t} form={form} u={updateField} />

          <button type="submit" data-testid="survey-submit-btn" disabled={loading} className="w-full bg-[#FF3B30] text-white font-heading uppercase tracking-widest px-8 py-4 text-sm hover:bg-[#FF5C53] transition-all hover:-translate-y-0.5 disabled:opacity-50">
            {loading ? "..." : t.submit}
          </button>
        </form>
      </div>
    </div>
  );
}
